import { useSelector } from 'react-redux';

import { PageLayout, Panel } from '../../shared/interface/index.js';
import { RouterSelectors } from '../../store/index.js';
import { VerifyEmail, ResetPassword } from '../index.js';

const ActionModes = {
    VerifyEmail: 'verifyEmail',
    ResetPassword: 'resetPassword',
};

const EmailActionPage: FC = () => {
    const emailAction = useSelector(RouterSelectors.emailAction);
    const { mode, oobCode } = emailAction;

    const content = () => {
        if (!mode || !oobCode) {
            return (
                <div className="p-3">
                    <div className="alert alert-danger">This link is invalid or expired</div>
                </div>
            );
        }

        if (mode === ActionModes.VerifyEmail) {
            return <VerifyEmail />;
        }

        if (mode === ActionModes.ResetPassword) {
            return <ResetPassword />;
        }

        return null;
    };

    return <PageLayout right={<Panel content={content()} />} />;
};

export default EmailActionPage;
